/* eslint react/no-direct-mutation-state: "off", eqeqeq: "off" */
import React, { Component } from "react";
import { Col, FormGroup, Label, Form } from "reactstrap";
import { connect } from "react-redux";
import '../../../../Assets/styles/BuildingTree.css';
import { SaveWorkOrderBuilding, GetWorkOrderBuildings, GetWorkOrderBuilding, ChangeDisplayinWorkOrderBuilding, UpdateWorkOrderBuilding, GetBuildingsTimeZones } from "../../../../action/workorderAction";
import { Icon } from 'semantic-ui-react';
import {MdSave} from 'react-icons/md';

const ErrorPadding = {
    color: '#D42D27',
    fontfamily: 'Lato',
    fontStyle: 'italic',
    border: '2px solid #D42D27',
    height: '40px',
    padding: '10px',
    float: 'right',
};

const ErrorSign = {
    color: '#D42D27',
    paddingLeft: '8px',
    paddingTop: '0px',
    paddingRight: '14px',
    width: '22px',
    height: '22px',
    top: '406px',
    left: '959px'
};
let EditBuildingDetails, isEdit;
class AddWorkOrderBuilding extends Component {
    constructor(props) {
        super(props);
        this.state = {
            IsError: false,
            IsDuplicateError: false,
            SelectedBuildingName: '',
            TimeZoneId: 7,
            error: {
                name: false,
                email: false
            }
        };
    }

    componentWillMount(){
        this.props.GetBuildingsTimeZones();
        EditBuildingDetails = this.props.EditBuildingDetails;
        isEdit = this.props.IsEdit;  
        if(EditBuildingDetails !== undefined && EditBuildingDetails !== null) 
            this.setState({SelectedBuildingName : EditBuildingDetails.name})
    }

    AllowOnlyTexts = (event) => {
        var regex = new RegExp("^[a-zA-Z ]+$");
        var inputValue = String.fromCharCode(event.keyCode || event.which);
        // allow letters and whitespaces only.
        if (!regex.test(inputValue)) {
            event.preventDefault();
        }
    }

    AllowOnlyNumbers = (event) => {
        var regex = new RegExp("^[0-9]*$");
        var inputValue = String.fromCharCode(event.keyCode || event.which);
        // allow numbers only.
        if (!regex.test(inputValue)) {
            event.preventDefault();
        }
    }

    CancelBuilding(){
        if(isEdit)
            this.props.ChangeDisplayinWorkOrderBuilding('ViewBuilding',EditBuildingDetails.id); 
        else
            this.props.ChangeDisplayinWorkOrderBuilding('BuildingList',''); 
    }

    SaveNewBuilding(){
        let IsValid = true;
        this.state.error.name = false;
        this.setState({IsError:false, IsDuplicateError: false});
        let Email= new RegExp("^\\w+([\\.]*[\\-]*\\w+[\\.]*[\\-]*)*@(\\w+[\\-]*)+(\\.\\w{2,3})+$");
        let Building_Name = this.refs.building_name_input.value;
        let Building_FName = this.refs.building_first_name_input.value;
        let Building_LName = this.refs.building_last_name_input.value;
        let Building_Address = this.refs.building_address_input.value;
        let Building_Email = this.refs.building_email_input.value;
        let Building_City = this.refs.building_city_input.value;
        let Building_State = this.refs.building_state_input.value;
        let Building_ZipCode  = this.refs.building_zip_input.value;
        let Building_Primary_Phone = this.refs.building_primary_phone_input.value;
        let Building_Secondary_Phone = this.refs.building_secondary_phone_input.value;
        if(Building_Name.trim() === "" || Building_Name === undefined){
            IsValid = false;
            this.setState({IsError:true});
            this.state.error.name = true;
        }else{
            this.state.error.name = false;
        }

        if(this.props.getWorkOrderBuildingList != undefined && this.props.getWorkOrderBuildingList.WorkorderBuildings != null){
            let lstBuildings = this.props.getWorkOrderBuildingList.WorkorderBuildings.filter(el => el.isDeleted == false);
            if(lstBuildings != undefined && lstBuildings.length > 0){
                lstBuildings = lstBuildings.filter(function(item){
                    return Building_Name == item.name
                });
                if(lstBuildings != null && lstBuildings.length > 0){
                    if (lstBuildings[0].name !== this.state.SelectedBuildingName) {
                        IsValid = false;
                        this.setState({IsDuplicateError:true});
                        this.state.error.name = true;
                    }
                }
            }
        }

        if(Building_Email != null && Building_Email != ""){
            if(!Email.test(Building_Email)){
                IsValid = false;
                this.state.error.email = true;
                this.setState({IsError: true});
            }else{
                this.state.error.email = false;
            }  
        }else{
            this.state.error.email = false;
        }


        if(IsValid){
            var selectedOption = this.refs.timeZoneOptions.options.selectedIndex;
            
            var Data = {
                "Name": Building_Name.trim(),
                "SiteId": 0,
                "Address": {
                    "StreetAddress1": Building_Address,
                    "StateOrProvince": Building_State,
                    "City": Building_City,
                    "PostalCode": Building_ZipCode
                },
                "ContactInformation":{
                    "FirstName": Building_FName,
                    "LastName": Building_LName,
                    "EmailAddress": Building_Email,
                    "PrimaryPhone": Building_Primary_Phone,
                    "SecondaryPhone": Building_Secondary_Phone
                },
                "IsDaylightSavingTimeEnabled": this.refs.dayLightSavingsYes.checked,
                "TimeZone": this.refs.timeZoneOptions.options[selectedOption].value
            }
            
            if(!isEdit){
                let Buildings = [];
                Buildings.push(Data);
                const actionResponse = this.props.SaveWorkOrderBuilding(Buildings);
                actionResponse.then((result) => {
                    this.props.GetWorkOrderBuildings();
                    this.props.ChangeDisplayinWorkOrderBuilding('BuildingList','');
                })
            }
            else{
                Data.SiteId = EditBuildingDetails.siteId;
                const action_Response = this.props.UpdateWorkOrderBuilding(Data,EditBuildingDetails.id);
                action_Response.then((result) => {
                    const action_Response1 = this.props.GetWorkOrderBuilding(EditBuildingDetails.id);
                    action_Response1.then((res) => {
                        this.props.GetWorkOrderBuildings();
                        this.props.ChangeDisplayinWorkOrderBuilding('ViewBuilding',EditBuildingDetails.id); 
                    })
                })                 
            }
        }         
    }

    render() {
        let adminLabel = this.props.getAdminLabels;
        var timeZoneArray = [];
        //let label = this.props.getLabels;
        let BuildingName,Fname,Lname,Streetname,Email,City,State,Zipcode,Primaryphone,Secondaryphone,TimeZone = this.state.TimeZoneId,DayLightSavings = true;
        var Error_Msg;
        if(this.state.IsError || this.state.IsDuplicateError){
            Error_Msg = <p style={ErrorPadding}>
                <Icon name='exclamation triangle' style={ErrorSign} /><b>Please correct all errors before continuing.</b>
            </p>
        }

        if(isEdit && EditBuildingDetails !== null){
            BuildingName = EditBuildingDetails.name;
            Fname = EditBuildingDetails.contactInformation.firstName;
            Lname = EditBuildingDetails.contactInformation.lastName;
            Streetname = EditBuildingDetails.address.streetAddress1;
            Email = EditBuildingDetails.contactInformation.emailAddress;
            City = EditBuildingDetails.address.city;
            State = EditBuildingDetails.address.stateOrProvince;
            Zipcode = EditBuildingDetails.address.postalCode;
            Primaryphone = EditBuildingDetails.contactInformation.primaryPhone;
            Secondaryphone = EditBuildingDetails.contactInformation.secondaryPhone;
            TimeZone = EditBuildingDetails.timeZone;
            DayLightSavings = EditBuildingDetails.isDaylightSavingTimeEnabled;
        }

        if (this.props.getTimeZones != undefined) {
            var timezones = this.props.getTimeZones;

            for(var key in timezones) {
                var lineItem = {
                    "key" : key,
                    "value": timezones[key]
                }
                timeZoneArray.push(lineItem);
            }

            var timeZoneOptions = timeZoneArray.map((el,i)=>(
            <option value={el.key} selected={el.key == TimeZone}>{'['+adminLabel['EnumGMT.'+el.key+'.Text']+'] - '+adminLabel['EnumGMTLong.'+el.key+'.Text']}</option>
            ));
        }

        return (
            <div className="main_container">
                {Error_Msg}
                <Form>
                    <FormGroup row style={{ "margin-bottom": "1px" }}>
                        <Col sm={{ size: 4 }}>
                            <Label className='workordermainheaderlbl'>{isEdit ? "Edit Building" : "Add Building"}</Label>
                        </Col>
                        <Col sm={{ size: 8 }}>
                            <div className="workorderbtn-cancel" onClick={() => { this.CancelBuilding() }} style={{ 'float': 'right', 'margin-left': '6px' }}>CANCEL</div>
                            <div className="workorderbtn-save" onClick={() => { this.SaveNewBuilding() }} style={{ 'float': 'right' }}><MdSave style={{ width: '15px', height: '15px', 'margin-right': '3px' }} />SAVE</div>
                        </Col>
                    </FormGroup>
                    <FormGroup row style={{ "margin-bottom": "1px" }}>
                        <Col sm={{ size: 12 }}>
                            <hr style={{ backgroundColor: '#666666', border: 'none', height: '1px' }} />
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Col sm={{ size: 6 }}>
                            <Label className='workordermainheaderlbl'>Building Details</Label>
                        </Col>
                        <Col sm={{ size: 6 }}>
                            <Label className='workordermainheaderlbl'>Main Contact</Label>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Col sm={{ size: 6 }}>
                            <Label className={(this.state.error.name) ? "errortext workorderlbl CreatePMlbl_margin" : "workorderlbl CreatePMlbl_margin"}>Name</Label><br />
                            <input type="text" ref='building_name_input' className={(this.state.error.name) ? "errorhighlight pm_textbox" : "pm_textbox"} defaultValue={BuildingName} />
                            <span hidden={!this.state.error.name}><Icon name='exclamation triangle' style={ErrorSign} /><br />
                                <Label style={{ 'color': '#D42D27', 'font-style': 'italic', 'font-size': '10px', 'font-family': 'Lato' }}><b>{this.state.IsDuplicateError ? "Duplicate Building Name" : "An entry is required"}</b></Label></span>
                        </Col>
                        <Col sm={{ size: 6 }}>
                            <table>
                                <tr>
                                    <td><Label className="workorderlbl CreatePMlbl_margin">First Name</Label></td>
                                    <td style={{ 'padding-left': '9px' }}><Label className="workorderlbl CreatePMlbl_margin">Last Name</Label></td>
                                </tr>
                                <tr>
                                    <td><input type="text" ref='building_first_name_input' className="pm_textbox" defaultValue={Fname} /></td>
                                    <td style={{ 'padding-left': '9px' }}><input type="text" ref='building_last_name_input' className="pm_textbox" defaultValue={Lname} /></td>
                                </tr>
                            </table>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Col sm={{ size: 6 }}>
                            <Label className="workorderlbl CreatePMlbl_margin">Street Address</Label><br />
                            <input type="text" ref='building_address_input' className="pm_textbox" defaultValue={Streetname} />
                        </Col>
                        <Col sm={{ size: 6 }}>
                            <Label className={(this.state.error.email) ? "errortext workorderlbl CreatePMlbl_margin" : "workorderlbl CreatePMlbl_margin"} style={{ 'padding-right': "190px" }}>Email Address</Label>
                            <br />
                            <input type="text" ref='building_email_input' className={(this.state.error.email) ? "errorhighlight pm_textbox" : "pm_textbox"} defaultValue={Email} />
                            <span hidden={!this.state.error.email}><Icon name='exclamation triangle' style={ErrorSign} /><br />
                                <Label style={{ 'color': '#D42D27', 'font-style': 'italic', 'font-size': '10px', 'font-family': 'Lato' }}><b>In valid email</b></Label></span>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Col sm={{ size: 6 }}>
                            <table>
                                <tr>
                                    <td><Label className="workorderlbl CreatePMlbl_margin">City</Label></td>
                                    <td style={{ 'padding-left': '9px' }}><Label className="workorderlbl CreatePMlbl_margin">State</Label></td>
                                    <td style={{ 'padding-left': '9px' }}><Label className="workorderlbl CreatePMlbl_margin">Zip</Label></td>
                                </tr>
                                <tr>
                                    <td><input type="text" onKeyPress={this.AllowOnlyTexts} ref='building_city_input' className="pm_textbox" defaultValue={City} /></td>
                                    <td style={{ 'padding-left': '9px' }}><input type="text" onKeyPress={this.AllowOnlyTexts} ref='building_state_input' className="pm_textbox" defaultValue={State} /></td>
                                    <td style={{ 'padding-left': '9px' }}><input type="text" onKeyPress={this.AllowOnlyNumbers} ref='building_zip_input' className="pm_textbox" defaultValue={Zipcode} /></td>
                                </tr>
                            </table>
                        </Col>
                        <Col sm={{ size: 6 }}>
                            <table>
                                <tr>
                                    <td><Label className="workorderlbl CreatePMlbl_margin">Primary Phone</Label></td>
                                    <td style={{ 'padding-left': '9px' }}><Label className="workorderlbl CreatePMlbl_margin">Secondary Phone</Label></td>
                                </tr>
                                <tr>
                                    <td><input type="text" onKeyPress={this.AllowOnlyNumbers} ref='building_primary_phone_input' className="pm_textbox" defaultValue={Primaryphone}/></td>
                                    <td style={{ 'padding-left': '9px' }}><input type="text" onKeyPress={this.AllowOnlyNumbers} ref='building_secondary_phone_input' className="pm_textbox" defaultValue={Secondaryphone} /></td>
                                </tr>
                            </table>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Col sm={{ size: 6 }}>
                            <table>
                                <tr>
                                    <td><Label className="workorderlbl CreatePMlbl_margin">Time Zone</Label></td>
                                    <td style={{ 'padding-left': '20px' }}><Label className="workorderlbl CreatePMlbl_margin">Adjust for Daylight Savings Time</Label></td>
                                </tr>
                                <tr>
                                    <td>
                                        <select name="add_building_timezone" ref="timeZoneOptions" className="minimal workorderedit-dropdown">
                                            {timeZoneOptions}
                                        </select>
                                    </td>
                                    <td style={{ 'padding-left': '9px' }}>
                                        <input type="radio" ref="dayLightSavingsYes" name="daylight" id="rdbYes" style={{ marginLeft: "10px", verticalAlign: "middle" }} defaultChecked={DayLightSavings} /><span className="workorderlbl">Yes</span>
                                        <input type="radio" ref="dayLightSavingsNo" name="daylight" id="rdbNo" style={{ marginLeft: "9px", verticalAlign: "middle" }} defaultChecked={DayLightSavings ? false : true} /><span className="workorderlbl">No</span>
                                    </td>
                                </tr>
                            </table>
                        </Col>
                        <Col sm={{ size: 6 }}>
                        </Col>
                    </FormGroup>
                </Form>
            </div>
        );

    }
};
const mapStateToProps = state => {
    return {
        getLabels: state.CulturalLabelsRootReducer.WorkOrderResource_LabelsBasedOnPreference,
        getWorkOrderBuildingList: state.WorkorderRootReducer,
        getTimeZones: state.InstallationsRootReducer.BuildingsTimeZones,
        getAdminLabels: state.CommonResourceDataRootReducer.CommonResourcesData
    };
};


const mapDispatchToProps = dispatch => {
    return {
        SaveWorkOrderBuilding: (data) => dispatch(SaveWorkOrderBuilding(data)),
        UpdateWorkOrderBuilding: (data,id) => dispatch(UpdateWorkOrderBuilding(data,id)),
        GetWorkOrderBuildings: () => dispatch(GetWorkOrderBuildings()),
        GetWorkOrderBuilding: (Id) => dispatch(GetWorkOrderBuilding(Id)),
        ChangeDisplayinWorkOrderBuilding: (data,building) => dispatch(ChangeDisplayinWorkOrderBuilding(data,building)),
        GetBuildingsTimeZones:() => dispatch(GetBuildingsTimeZones())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddWorkOrderBuilding);